let _audioCtx = null;

export const playChime = () => {
  try {
    _audioCtx = _audioCtx || new (window.AudioContext || window.webkitAudioContext)();
    const ctx = _audioCtx;
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    [880, 1320].forEach((f, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = f;
      o.connect(g);
      g.connect(ctx.destination);
      const t0 = now + i * 0.12;
      g.gain.setValueAtTime(0, t0);
      g.gain.linearRampToValueAtTime(0.06, t0 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.22);
      o.start(t0);
      o.stop(t0 + 0.24);
    });
  } catch (e) { console.error(e); }
};

export const notifyBrowser = (alerts) => {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") return;
    (alerts || []).slice(0, 3).forEach((a) => {
      new Notification(a.title || "Tharwy alert", { body: a.message || "", tag: a.id });
    });
  } catch (e) { console.error(e); }
};

// True when the user's local time falls inside their configured quiet-hours window.
export const inQuietWindow = (prefs) => {
  if (!prefs || !prefs.quiet_hours_enabled) return false;
  const toMin = (s) => {
    const [h, m] = String(s || "0:0").split(":").map((n) => parseInt(n, 10) || 0);
    return h * 60 + m;
  };
  const now = new Date();
  const cur = now.getHours() * 60 + now.getMinutes();
  const start = toMin(prefs.quiet_hours_start);
  const end = toMin(prefs.quiet_hours_end);
  if (start === end) return false;
  if (start < end) return cur >= start && cur < end;   // same-day window
  return cur >= start || cur < end;                    // overnight wrap
};
